import { render, staticRenderFns } from "./newaddmember.vue?vue&type=template&id=54c8e528&scoped=true&"
import script from "./newaddmember.vue?vue&type=script&lang=js&"
export * from "./newaddmember.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=54c8e528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8e528",
  null
  
)

export default component.exports